import React from 'react';
import { bool, number, oneOf } from 'prop-types';

import LinearProgress from '@material-ui/core/LinearProgress';

import EsmsModal from '../../components/EsmsModal';

const ActionTitles = {
    create: 'Creating',
    delete: 'Deleting'
};

const DeviceModificationModal = ({
    completed,
    modificationType,
    open,
    pending
}) => {
    return (
        <EsmsModal
            open={open}
            title={`${ActionTitles[modificationType]} Devices...`}
        >
            <LinearProgress
                value={completed}
                valueBuffer={pending}
                variant="buffer"
            />
        </EsmsModal>
    );
};

DeviceModificationModal.defaultProps = {
    completed:        0,
    modificationType: oneOf(Object.keys(ActionTitles)),
    open:             false,
    pending:          0
};

DeviceModificationModal.propTypes = {
    completed: number,
    open:      bool,
    pending:   number
};

export default DeviceModificationModal;
